import {Menu, MenuItem, styled} from '@mui/material';

const StyledMenu = styled(Menu)(() => ({
    '& .MuiPaper-root': {
        fontFamily: 'Gilroy-Medium',
    },
    '& .MuiMenuItem-root': {
        fontFamily: 'Gilroy-Medium',
        fontSize: '1rem',
        fontWeight: 400,
        color: 'rgba(0, 0, 0, 0.87)',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        }
    }
}));

const StyledMenuItem = styled(MenuItem)(() => ({
    fontFamily: 'Gilroy-Medium',
    fontSize: '1rem',
    fontWeight: 400,
    color: 'rgba(0, 0, 0, 0.87)',
    padding: '4px 24px',
    minWidth: '7rem'
}));

export { StyledMenu, StyledMenuItem };